"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up8"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down7"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BySession = function BySession(props) {
  var _props$data = props.data,
    highestFidelitySession = _props$data.highestFidelitySession,
    lowestFidelitySession = _props$data.lowestFidelitySession;
  var colors = props.colors;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].left,
    style: colors ? {
      borderRight: "1px solid ".concat(colors.primary)
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].heading,
    style: colors ? {
      color: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], {
    spaceRight: true
  }), "Highest Fidelity"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].mediumFont,
    style: colors ? {
      color: colors.primary
    } : {}
  }, "Session"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].bigFont,
    style: colors ? {
      color: colors.primary
    } : {}
  }, highestFidelitySession))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].right
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].heading,
    style: colors ? {
      color: colors.primary
    } : {}
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
    spaceRight: true
  }), "Lowest Fidelity"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].mediumFont,
    style: colors ? {
      color: colors.primary
    } : {}
  }, "Session"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].bigFont,
    style: colors ? {
      color: colors.primary
    } : {}
  }, lowestFidelitySession))));
};
var _default = exports["default"] = BySession;